export default function focalPointToObjectPosition({
  x,
  y,
}: {
  x: number
  y: number
}): string {
  if (!x || !y) {
    return "center"
  } else {
    return `${x * 100}% ${y * 100}%`
  }
}
